export default [
  {
    id: 1,
    label: "위험기계 사용 작업",
    check: true,
    title: "위험기계 사용 작업",
    list: [
      {
        headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        headerYesTitle: "양호",
        headerNoTitle: "불량",
        headerNATitle: "N/A",
        isTypeMode: false,
        isInputMode: false,
        list: [
          {
            id: 1,
            label: "• 사용 기계·기구·설비 방호조치",
            is_checked: "",
          },
          {
            id: 2,
            label: "• 작업구역 설정(출입경고 표지)",
            is_checked: "",
          },
          {
            id: 3,
            label: "• 인화성액체 사용시 소화기 비치",
            is_checked: "",
          },
          {
            id: 4,
            label: "• 화기작업시 인화물질 제거",
            is_checked: "",
          },
          {
            id: 5,
            label: "• 화기작업시 불꽃방지막 사용",
            is_checked: "",
          },
          {
            id: 6,
            label: "• 보호구 착용",
            is_checked: "",
          },
          {
            id: 7,
            label: "• 안전교육",
            is_checked: "",
          },
          {
            id: 8,
            label: "• 외부인 접근금지 조치",
            is_checked: "",
          },
          {
            id: 9,
            label: "• 정전조치시 잠금 및 표지부착",
            is_checked: "",
          },
          {
            id: 10,
            label: "• 조명장비  ",
            is_checked: "",
          },
        ],
      },
    ],
  },
];
